<template>
  <div style="position: relative">
    <a-spin v-if="loading || !shareData" style="width: 100%;height: 100%" />
    <img v-else :src="image" class="image"/>
    <div class="poster" ref="poster">
      <div class="poster-header">
        <img class="logo" :src="shareData.logo"/>
        <div class="code">邀请码 {{shareData.invite_code}}</div>
      </div>

      <img :src="shareData.poster_image" class="image"/>
      <div style="display: flex;flex-grow: 1;">
        <div class="poster-content">
          <div class="poster-title">

            <span class="provider">{{shareData.provider_name}}</span>
            <span>
              {{shareData.title}}
            </span>
          </div>
          <div class="footer">
            <div class="tag">到手价</div>
            <div class="price"><span style="font-size: 20px;">￥</span>{{shareData.coupon_price}}</div>
          </div>
        </div>

        <img :src="shareData.qrcode_url" class="qrcode"/>
      </div>
    </div>
  </div>

</template>

<script>
import html2canvas from 'html2canvas';
export default {
  name: "poster",
  props: {
    shareData: Object
  },
  watch: {
    shareData: {
      handler(nValue, oValue) {
        if (nValue) {
          this.draw()
        } else {
          this.loading = true
          this.image = undefined
        }
        console.log(nValue, oValue)

      },
      immediate: true
    },
  },
  data() {
    return {
      loading: true,
      image: undefined
    }
  },
  mounted() {
  },
  methods: {
    draw() {
      this.loading = true
      this.$nextTick(()=> {
        html2canvas(this.$refs.poster, { useCORS: true, logging: true , scale: 3}).then((canvas) => {
          const dataURL = canvas.toDataURL('image/png');
          console.log(dataURL)
          this.image = dataURL
          this.loading = false
        });
      })


    },
    saveImage() {
      const clientWidth = this.$refs.poster.offsetWidth;
      const clientHeight = this.$refs.poster.offsetHeight;
      const kh = [clientWidth, clientHeight];
      console.log(this.image)
      this.download(this.image, kh);
    },
    getUrlBase64(url, kh) {
      return new Promise((resolve) => {
        let canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const img = new Image();
        img.crossOrigin = 'Anonymous'; // 允许跨域
        img.src = url;
        img.onload = () => {
          // eslint-disable-next-line prefer-destructuring
          canvas.height = kh[1];
          // eslint-disable-next-line prefer-destructuring
          canvas.width = kh[0];
          ctx.drawImage(img, 0, 0, kh[0], kh[1]);
          const dataURL = canvas.toDataURL('image/png');
          canvas = null;
          resolve(dataURL);
        };
      });
    },
    download(imgUrl, kh) {
      this.getUrlBase64(imgUrl, kh).then((base64) => {
        const link = document.createElement('a');
        link.href = base64;
        link.download = `poster.png`;
        link.click();
      });
    },
  }
}
</script>

<style scoped lang="scss">
.image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.poster {
  padding: 40px;
  position: absolute;
  left: -100000px;
  right: -100000px;
  width: 560px;
  height: 896px;
  background: white;
  display: flex;
  flex-direction: column;


  .poster-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .logo {
      height: 80px;
      object-fit: contain;
    }
    .code {
      height: 72px;
      padding-left: 20px;
      padding-right: 20px;
      line-height: 72px;
      font-size: 28px;
      color: #333333;
      background: #f9f9f9;
      border-radius: 36px;
    }
  }

  .image {
    width: 480px;
    height: 480px;
    border-radius: 20px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .poster-content {
    margin-right: 12px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .poster-title {
      font-size: 30px;
      font-weight: bold;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      .provider {
        height: 32px;
        padding-left: 8px;
        padding-right: 8px;
        border-radius: 8px;
        background: #ff4242;
        color: white;
        font-size: 24px;
        line-height: 32px;
      }
    }

    .footer {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      .tag {
        height: 24px;
        padding-left: 20px;
        padding-right: 20px;
        border-radius: 8px;
        background: #ff4242;
        line-height: 24px;
        font-size: 18px;
        color: white;
      }
      .price {
        font-size: 32px;

      }
    }
  }

  .qrcode {
    width: 160px;
    height: 160px;
  }
}
</style>
